import { ChangeDetectorRef, Component } from '@angular/core';

import { Keepalive } from '@ng-idle/keepalive';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';

import { environment } from '@environments/environment';
import Resources from './core/constants/resourses';

import { SessionService } from './core/services/session.service';
import { UtilityService } from '@services/utility.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  idleState = "NOT_STARTED";
  countdown?: number = null;
  lastPing?: Date = null;
  ipAddress: any;

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private cd: ChangeDetectorRef,
    private utility: UtilityService,
    private sessionService: SessionService,
  ) {
    // set idle parameters
    idle.setIdle(3600); // will consider idle state start after given seconds. i.e 5 seconds
    idle.setTimeout(10); // After idle state started, countdown for given seconds to timeout. 
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // provide sources that will "interrupt" aka provide events indicating the user is active

    // On Idle state starting
    this.idle.onIdleStart.subscribe(() => {
      this.idleState = 'IDLE';
    });

    // On Idle state ended
    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = "NOT_IDLE";
      this.countdown = null;
      cd.detectChanges(); // how do i avoid this kludge?
    });

    //
    this.idle.onTimeout.subscribe(() => {
      this.idleState = "TIMED_OUT";
      this.sessionService.clearLocalStorage();
      this.sessionService.clearSessionStorage();
      window.open(environment.home_url, '_self');
    });

    // do something as the timeout countdown does its thing
    this.idle.onTimeoutWarning.subscribe(seconds => {
      this.countdown = seconds;
    });

    // set keepalive parameters, omit if not using keepalive
    keepalive.interval(10); // will ping at this interval while not idle, in seconds
    keepalive.onPing.subscribe(() => {
      this.lastPing = new Date();
    });

    // Make sure CTM flows variant and postcode variant are set in cookies to A/B testing 100% now.
    this.utility.setCookie(Resources.ABtestingKeys.CTM_FLOW_VARIANT_COOKIE, 'A', 30*24); // 30 days
    this.utility.setCookie(Resources.ABtestingKeys.LANDING_PAGE_VARIANT_COOKIE, 'A', 30*24); // 30 days
  }

  ngOnInit(): void {
    this.utility.getIPAddress().subscribe({
      next: (res) => {
        this.sessionService.setItemIntoSession(Resources.SessionStorageKeys.IpAddress, res?.ip);
      }, error: (err) => {
        console.log('Error while fetching IP address', err);
      }
    })

    // Reset the idle process
    this.reset();

    // Tealium data added
    this.sessionService.setItemIntoSession(Resources.SessionStorageKeys.TealiumData, {
      app_name: environment.tealium_app_name,
      app_version: environment.tealium_app_version,
      app_platform: environment.tealium_app_platform
    });
  }

  reset() {
    // we'll call this method when we want to start/reset the idle process
    // reset any component state and be sure to call idle.watch()
    this.idle.watch();
    this.idleState = "NOT_IDLE";
    this.countdown = null;
    this.lastPing = null;
  }
}
